export default __webpack_public_path__ + "static/ceotestimonial-9bd57ca2893272c4317a758dece13193.png";